import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactToPrint from 'react-to-print';
import config from 'config';
import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-js-pagination';
import LibraryApiCall from 'LibraryApiCall';
import 'LIBRARY/Components/Settings/DueDateNotification/DueDateNotification.css';

class NotificationHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notificationHiatoryModal: false,

            searchByErpId: '',
            searchByFromDate: '',
            seacrhByToDate: '',
            searchByType: 'email',

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Date and Time", isVisible: true },
                { name: "Type", isVisible: true },
                { name: "Send To", isVisible: true },
                { name: "ERP ID", isVisible: true },
                { name: "Send By", isVisible: true },
                // { name: "Status", isVisible: true },
            ],

            notificationHistoryData: [],
            notificationHistoryDataLoading: false,
            notificationHistoryDataTotalCount: 0,
            pageIndex: 1,
            limit: 10,

            //STATE FOR header
            exportCSVHeaders: [
                { label: "Date and Time", key: 'dateTime' },
                { label: 'Type', key: 'type' },
                { label: 'Send To', key: 'sendTo' },
                { label: 'ERP ID', key: 'erpId' },
                { label: "Send By", key: 'sendBy' },
                // { label: "Status", key: 'status' },
            ],

            exportItemVisibility: [
                { name: "Date and Time", isVisible: true },
                { name: "Type", isVisible: true },
                { name: "Send To", isVisible: true },
                { name: "ERP ID", isVisible: true },
                { name: "Send By", isVisible: true },
                // { name: "Status", isVisible: true },
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: [],
            allSortedIdArray: [],
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.isShowNotificationHistory != prevProps.isShowNotificationHistory && this.props.isShowNotificationHistory == true) {
            this.openNotificationHistoryModal()
        } else if (this.props.isShowNotificationHistory != prevProps.isShowNotificationHistory && this.props.isShowNotificationHistory == false) {
            this.closeNotificationHistoryModal()
        }
    }

    openNotificationHistoryModal = () => {
        this.setState({
            notificationHiatoryModal: true
        }, () => {
            this.GetIssueReturnMailHistoryReport();

        })
    }

    closeNotificationHistoryModal = () => {
        this.setState({
            notificationHiatoryModal: false,
        })
        this.props.closeModalForNotificationHistory();

    }

    // CLEAR ALL FILTER
    handleClearAllHistory = () => {
        this.setState({
            searchByErpId: '',
            searchByFromDate: '',
            seacrhByToDate: '',
            searchByType: 'email',
        }, () => {
            this.GetIssueReturnMailHistoryReport()
        })
    };


    // API CALL TO GET notification DATA LIST
    GetIssueReturnMailHistoryReport = async () => {
        this.setState({ notificationHistoryDataLoading: true })

        let requestData = {
            "iid": config.institute_id,
            "pageIndex": this.state.pageIndex,
            "limit": this.state.limit,
            "fromDate": this.state.searchByFromDate,
            "toDate": this.state.seacrhByToDate,
            "type": this.state.searchByType,
            "erpId": this.state.searchByErpId
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetIssueReturnMailHistoryReport',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetIssueReturnMailHistoryReport();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult.success == 'true') {

                    const { data, sequenceIDArray, totalCount } = apiResult;

                    const orderedNotificationHistoryData = sequenceIDArray.map((id) => data[id]);

                    this.setState({
                        notificationHistoryData: orderedNotificationHistoryData,
                        notificationHistoryDataLoading: false,
                        notificationHistoryDataTotalCount: totalCount
                    })
                }
                else {
                    this.setState({
                        notificationHistoryData: [],
                        notificationHistoryDataLoading: false,
                        notificationHistoryDataTotalCount: 0,
                    })
                }
            } else {
                this.setState({
                    notificationHistoryData: [],
                    notificationHistoryDataLoading: false,
                    notificationHistoryDataTotalCount: 0,
                })
            }
        }
    }

    // filter erp on change
    handleERPIdChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByErpId: event.target.value });
    };
    handleErpIdKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetIssueReturnMailHistoryReport();
        }
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber, searchByErpId: this.state.searchByErpId, searchByFromDate: this.state.searchByFromDate, seacrhByToDate: this.state.seacrhByToDate, searchByType: this.state.searchByType }, () => {
            this.GetIssueReturnMailHistoryReport();
        });
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({ pageIndex: 1, limit: event.target.value, searchByErpId: this.state.searchByErpId, searchByFromDate: this.state.searchByFromDate, seacrhByToDate: this.state.seacrhByToDate, searchByType: this.state.searchByType }, () => {
            this.GetIssueReturnMailHistoryReport();
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            // if (action != 'onLoad') {
            this.exportCSVData();
            // }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterERPId = this.state.searchByErpId
        let filterFromDate = this.state.searchByFromDate
        let filterToDate = this.state.seacrhByToDate
        let filterType = this.state.searchByType

        if (filterERPId) {
            FilterArray.push(`ERP ID - ${filterERPId}`)
        }
        if (filterFromDate) {
            FilterArray.push(`Notification From Date - ${filterFromDate}`)
        }
        if (filterToDate) {
            FilterArray.push(`Notification To Date - ${filterToDate}`)
        }
        if (filterType) {
            FilterArray.push(`Notification Type - ${filterType}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllResourceTitleReport" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="6" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="6" style={{ textAlign: 'center' }}>
                                {this.props.headerName} Notification History
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="6" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="6" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="6" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Date and Time</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>Type</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Send To</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>ERP ID</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Send By</th>}
                        {/* {this.state.exportItemVisibilityForRows[5].isVisible && <th>Status</th>} */}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="6">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((notification, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{notification?.mailDateTime || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{notification?.type == "mobileNotification" ? "Mobile Notification" : notification?.type?.charAt(0).toUpperCase() + notification?.type?.slice(1)}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{notification?.userName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{notification?.userErpId || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{notification?.senderName || notification?.sentFrom?.charAt(0).toUpperCase() + notification?.sentFrom?.slice(1)}</td>}
                                            {/* {this.state.exportItemVisibilityForRows[5].isVisible && <td>{notification?.status || ""}</td>} */}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="6">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { notificationHistoryDataTotalCount } = this.state;
        const totalPages = Math.ceil(notificationHistoryDataTotalCount / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let jsonResponse;

            let requestData = {
                "iid": config.institute_id,
                "pageIndex": pageIndex,
                "limit": 50,
                "fromDate": this.state.searchByFromDate,
                "toDate": this.state.seacrhByToDate,
                // "type": this.props.type,
                "erpId": this.state.searchByErpId
            }

            jsonResponse = await LibraryApiCall.makeApiCall(
                'GetIssueReturnMailHistoryReport',
                requestData,
                '/api/library/instructor.php'
            )

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;

                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sequenceIDArray || [];

                    // Concatenate new data and update state
                    this.setState((prevState) => ({
                        allReportData: { ...allReportData, ...apiResult },
                        allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                        totalRecords: jsonResponse.APIResult.totalCount,
                    }), () => {
                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });

                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting notification history data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    notificationHiatoryModal = () => {
        let FilterArray = [];

        let filterERPId = this.state.searchByErpId
        let filterFromDate = this.state.searchByFromDate
        let filterToDate = this.state.seacrhByToDate
        let filterType = this.state.searchByType

        if (filterERPId) {
            FilterArray.push(`ERP ID - ${filterERPId}`)
        }
        if (filterFromDate) {
            FilterArray.push(`Notification From Date - ${filterFromDate}`)
        }
        if (filterToDate) {
            FilterArray.push(`Notification To Date - ${filterToDate}`)
        }
        if (filterType) {
            FilterArray.push(`Notification Type - ${filterType}`)
        }

        return (
            <>
                <div id="modalForNotificationHistory" className={this.state.notificationHiatoryModal ? 'modal fade show' : 'modal'} style={{ display: this.state.notificationHiatoryModal ? "block" : 'none', visibility: this.state.notificationHiatoryModal ? 'visible' : 'hidden' }}>
                    <div class="modal-dialog modal-lg--userdetails modal-dialog-centered" style={{ maxWidth: '80vw', margin: "auto" }}>
                        <div class="modal-content modal-dialog-scrollable modal_content">
                            <div class="modal-header modal_header">
                                <h5 class="modal-title" style={{ textAlign: 'left' }} id="exampleModalLabel">{this.props.headerName} Notification History</h5>
                                <span style={{ cursor: "pointer" }} onClick={() => {
                                    this.closeNotificationHistoryModal()
                                }}>
                                    <FontAwesomeIcon icon={['fas', 'times']} size={'md'} />
                                </span>
                            </div>
                            <div class="modal-body" style={{ maxHeight: "80vh", height: '80vh' }}>
                                <div className="">
                                    <div className="studentStatisticalReport">
                                        <div>
                                            {/* header */}
                                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                                <div className="d-flex col-md-12 px-0">
                                                    <div className="col-md-10 d-flex justify-content-start align-items-center p-0">
                                                        {/* action button - filter */}
                                                        <div className="d-flex">
                                                            <div>
                                                                {/* <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF' }}> */}
                                                                {/* filter data form*/}
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                                        {/* Based On Search by Name or ERP ID */}
                                                                        <div className="mb-2  p-1">
                                                                            <label className="vm_custom_body3" color='#454E52'>Send To</label>
                                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                                <img
                                                                                    src={searchPng}
                                                                                    style={{
                                                                                        position: 'absolute',
                                                                                        left: '10px',
                                                                                        top: '50%',
                                                                                        transform: 'translateY(-50%)',
                                                                                        color: '#ccc',
                                                                                        backgroundColor: 'white',
                                                                                        width: '15px',
                                                                                        height: '15px',
                                                                                        zIndex: 1,
                                                                                    }}
                                                                                />
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control formControlAutoTask"
                                                                                    id="searchByTitleFilter"
                                                                                    placeholder="Search by ERP ID"
                                                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                                                                    value={this.state.searchByErpId} // Bind value to state
                                                                                    onChange={this.handleERPIdChange} // Handle input changes
                                                                                    onKeyPress={this.handleErpIdKeyPress} // Trigger API call on Enter
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="mb-2  p-1">
                                                                            <label className="vm_custom_body3" color='#454E52'>From Date</label>
                                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                                <input
                                                                                    type="date"
                                                                                    className="form-control"
                                                                                    style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                                                                    placeholder="Select From Date"
                                                                                    value={this.state.searchByFromDate}
                                                                                    onChange={(event) => {
                                                                                        this.setState({
                                                                                            searchByFromDate: event.target.value || '',
                                                                                        }, () => {
                                                                                            this.GetIssueReturnMailHistoryReport()
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="mb-2  p-1">
                                                                            <label className="vm_custom_body3" color='#454E52'>To Date</label>
                                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                                <input
                                                                                    type="date"
                                                                                    className="form-control"
                                                                                    style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                                                                    placeholder="Select To Date"
                                                                                    value={this.state.seacrhByToDate}
                                                                                    onChange={(event) => {
                                                                                        this.setState({
                                                                                            seacrhByToDate: event.target.value || '',
                                                                                        }, () => {
                                                                                            this.GetIssueReturnMailHistoryReport()
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="mb-2  p-1">
                                                                            <label className="vm_custom_body3" color='#454E52'>Type</label>
                                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                                <select
                                                                                    className="form-control formControlContentTask"
                                                                                    style={{
                                                                                        width: '165px',
                                                                                        height: '42px',
                                                                                        fontSize: "12px",
                                                                                        fontWeight: 400,
                                                                                        lineHeight: '20px',
                                                                                        fontFamily: "'Poppins', sans-serif",
                                                                                        color: '#808080',
                                                                                        borderRadius: '7px'
                                                                                    }}
                                                                                    id="searchByProgramFilter"
                                                                                    onChange={(e) => {
                                                                                        this.setState({ searchByType: e.target.value }, () => { this.GetIssueReturnMailHistoryReport() });
                                                                                    }}
                                                                                    value={this.state.searchByType}
                                                                                >
                                                                                    <option value="email">Email Notification</option>
                                                                                    <option value="sms">SMS Notification</option>
                                                                                    <option value="mobileNotification">Mobile Push Notification</option>
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Press "Enter" to get Notification History filter result.</p>
                                                                {/* </div> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2 d-flex justify-content-end align-items-center p-0">


                                                        {Object.keys(this.state.notificationHistoryData).length == 0 ? null :
                                                            <>
                                                                <div className="d-flex">
                                                                    {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                                                </div>

                                                                {/* 1 action button - export data */}
                                                                <div className="d-flex ml-2" title="Click to Export" >
                                                                    <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                                        {"@page { size: auto; }"}
                                                                    </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                                                    {/* 2.1 action button option - export and export all */}
                                                                    <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                                        <span>
                                                                            <div style={{ display: 'none' }}>
                                                                                <ReactHTMLTableToExcel
                                                                                    id="export"
                                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                                    table="resourceTitleReport"
                                                                                    filename="NotificationHistoryReport"
                                                                                    sheet="tablexls"
                                                                                    buttonText="Export to Excel "
                                                                                >
                                                                                </ReactHTMLTableToExcel>
                                                                            </div>
                                                                            <div style={{ display: 'none' }}>
                                                                                <ReactHTMLTableToExcel
                                                                                    id="exportAll"
                                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                                    table="ExportAllResourceTitleReport"   // export all functionality
                                                                                    filename="ExportAllNotificationHistoryReportData"
                                                                                    sheet="tablexls"
                                                                                    buttonText="Export All to Excel"
                                                                                />
                                                                            </div>
                                                                            <button
                                                                                onClick={this.formatCSVExportData}
                                                                                className="dropdown-item"
                                                                                title="Click to Export"
                                                                                style={{ boxShadow: 'none' }}
                                                                            >
                                                                                Export
                                                                            </button>
                                                                            {this.state.isExportAllReportDataFetching ? (
                                                                                <p className="dropdown-item">
                                                                                    Exporting report . . .&nbsp;
                                                                                    <FontAwesomeIcon
                                                                                        icon={["fas", "circle-notch"]}
                                                                                        className="rotate"
                                                                                    />
                                                                                </p>
                                                                            ) : (
                                                                                <button
                                                                                    onClick={() => this.setState({ allReportData: [] }, () => {
                                                                                        this.methodToExportReportData(0)
                                                                                    })}
                                                                                    className="dropdown-item"
                                                                                    title="Click to Export All"
                                                                                    style={{ boxShadow: 'none' }}
                                                                                >
                                                                                    Export All
                                                                                </button>
                                                                            )}
                                                                        </span>

                                                                    </div>

                                                                </div>

                                                                {/* 2 action button - print */}
                                                                <div className="d-flex ml-2" title="Click to Print">
                                                                    <span className="print-button">
                                                                        <ReactToPrint
                                                                            trigger={() => {
                                                                                return (
                                                                                    <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                                        <style type="text/css" media="print">
                                                                                            {"@page { size: auto; }"}
                                                                                        </style>
                                                                                        <span>
                                                                                            <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                                        </span>
                                                                                    </div>
                                                                                )
                                                                            }}
                                                                            content={() => this.componentRef}
                                                                        />
                                                                    </span>
                                                                </div>

                                                                {/* 3 action button - column visibility */}
                                                                <div className="d-flex ml-2" title="Click to Customize Columns">
                                                                    {/* <button className="print-button btn outline-button" style={{ borderRadius: '2.77px' }}> <style type="text/css" media="print">
                                        {"@page { size: auto; }"}
                                    </style> */}
                                                                    <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />
                                                                    {/* </button> */}

                                                                    {/* action modal - column visibility*/}
                                                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                                        <div id='settingDropdown' className='settingDropdown-body'>
                                                                            {
                                                                                this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                                                    return (
                                                                                        <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                                            <input type="checkbox" checked={columnInfo.isVisible} />
                                                                                        </p>
                                                                                    );
                                                                                })
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                (this.state.searchByErpId !== '' || this.state.searchByFromDate !== '' || this.state.seacrhByToDate !== '' || this.state.searchByType !== '') &&
                                                <div className='filter-apply'>
                                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllHistory}>Clear All</p>
                                                </div>
                                            }
                                        </div>

                                        {/* list table */}
                                        <div className="col-md-12 px-0 div_table">
                                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                                <div className="print-area" ref={el => this.componentRef = el}>
                                                    <div className="buildingReport_logo">
                                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                                        <h3>{this.props.headerName} Notification History</h3>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </div>
                                                    <table className="table table-bordered  vm_libraryReport_table" id="resourceTitleReport">
                                                        <thead>
                                                            <tr>
                                                                <tr className='d-none'>
                                                                    <th colSpan="6" style={{ textAlign: 'center' }}>
                                                                        {config.institute_name}
                                                                    </th>
                                                                </tr>
                                                                <tr className='d-none'>
                                                                    <th colSpan="6" style={{ textAlign: 'center' }}>
                                                                        {this.props.headerName} Notification History
                                                                    </th>
                                                                </tr>
                                                                <tr className='d-none'>
                                                                    <th colSpan="6" ></th>
                                                                </tr>
                                                                <tr className='d-none'>
                                                                    <th colSpan="6" style={{ textAlign: 'center' }}>
                                                                        {
                                                                            FilterArray.join(" | ")
                                                                        }
                                                                    </th>
                                                                </tr>
                                                                <tr className='d-none'>
                                                                    <th colSpan="6" ></th>
                                                                </tr>
                                                                <th>Sr.No</th>
                                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Date and Time</th>}
                                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>Type</th>}
                                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Send To</th>}
                                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>ERP ID</th>}
                                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Send By</th>}
                                                                {/* {this.state.exportItemVisibilityForRows[5].isVisible && <th>Status</th>} */}
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {
                                                                this.state.notificationHistoryDataLoading ?
                                                                    <tr>
                                                                        <td colSpan="6">
                                                                            <ButtonLoader />
                                                                        </td>
                                                                    </tr>
                                                                    :
                                                                    Object.keys(this.state.notificationHistoryData).length > 0 ?
                                                                        (Object.values(this.state.notificationHistoryData).map((notification, index) => {
                                                                            return (

                                                                                <tr key={index}>
                                                                                    <td>{
                                                                                        this.state.limit === 'all' ? index + 1 :
                                                                                            ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                                    }</td>
                                                                                    {this.state.exportItemVisibilityForRows[0].isVisible && <td>{notification?.mailDateTime || ""}</td>}
                                                                                    {this.state.exportItemVisibilityForRows[1].isVisible && <td>{notification?.type == "mobileNotification" ? "Mobile Notification" : notification?.type?.charAt(0).toUpperCase() + notification?.type?.slice(1)}</td>}
                                                                                    {this.state.exportItemVisibilityForRows[2].isVisible && <td>{notification?.userName || ""}</td>}
                                                                                    {this.state.exportItemVisibilityForRows[3].isVisible && <td>{notification?.userErpId || ""}</td>}
                                                                                    {this.state.exportItemVisibilityForRows[4].isVisible && <td>{notification?.senderName || notification?.sentFrom?.charAt(0).toUpperCase() + notification?.sentFrom?.slice(1)}</td>}
                                                                                    {/* {this.state.exportItemVisibilityForRows[5].isVisible && <td>{notification?.status || ""}</td>} */}
                                                                                </tr>
                                                                            )
                                                                        })) :
                                                                        <tr>
                                                                            <td colSpan="6">
                                                                                No data found.
                                                                            </td>
                                                                        </tr>
                                                            }


                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {/* table footer pagination */}
                                            {
                                                (Object.keys(this.state.notificationHistoryData).length > 0 || Object.keys(this.state.notificationHistoryData).length > this.state.limit) &&
                                                <div className='row px-0'>
                                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                                        <div className='row align-items-center justify-content-between'>
                                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id=""
                                                                            value={this.state.limit}
                                                                            onChange={this.changeShowEntriesControl}
                                                                        >
                                                                            <option value={10}>Entries Per Page 10</option>
                                                                            <option value={25}>Entries Per Page 25</option>
                                                                            <option value={40}>Entries Per Page 40</option>
                                                                            <option value={100}>Entries Per Page 100</option>
                                                                            <option value={250}>Entries Per Page 250</option>
                                                                        </select>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                                    <Pagination
                                                                        activePage={this.state.pageIndex}
                                                                        itemsCountPerPage={this.state.limit}
                                                                        totalItemsCount={this.state.notificationHistoryDataTotalCount}
                                                                        pageRangeDisplayed={3}
                                                                        onChange={this.updatePaginationCount}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {
                                                                this.returnExportAllData()
                                                            }

                                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                                    Total Records : {this.state.notificationHistoryDataTotalCount || 0}
                                                                </span>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        {/* {
                                            this.returnAdvanceFilterModelData()
                                        } */}
                                    </div >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    render() {

        return (
            <>
                {this.notificationHiatoryModal()}
            </>
        )
    }
}

export default NotificationHistory;